import React from "react";

/**
 * The platform's status symbol — earned, not assigned.
 *
 * Renders the official Armstrong K9 Registry gold wax-seal medallion
 * (the same artwork as the embed-kit badge and certificates) so the
 * mark reads identically everywhere it appears: kennel header crest,
 * directory cards, verified-marketplace listing corners, the embed
 * kit and the transfer-complete celebration screen.
 *
 * Sized off the `size` prop — safe to drop in at any size 16–96 px.
 * At 48 px and below it swaps to a simplified center-crop "gold coin"
 * (AK9 monogram + ring border) so the mark stays crisp instead of the
 * full medallion's ring text turning to mud.
 */
export const WaxSeal = ({ size = 36, title = "Verified kennel", className = "" }) => (
  <img
    src={size <= 48 ? "/ak9-seal-sm.png" : "/ak9-seal.png"}
    alt={title}
    title={title}
    role="img"
    aria-label={title}
    data-testid="luxury-wax-seal"
    className={`inline-block select-none flex-shrink-0 ${className}`}
    style={{
      width: size,
      height: size,
      filter: "drop-shadow(0 1px 2px rgba(110, 84, 8, 0.35))",
    }}
    draggable={false}
  />
);

export default WaxSeal;
